// @ts-nocheck
import { Plugin } from '/builds/t1_vSKCy2/0/lf/saas-eco/upselling-admin/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','request',],
});

export { plugin };
